/**
 * 共通
 */
 'use strict';
 import '@/_constant/global';
 import Sub from '@/_page/sub';
 window.gAMBR.mods['sub'] = new Sub();
 
 document.addEventListener('DOMContentLoaded', () => {
  gAMBR.mods['sub'].init();
 }, false);
 
 window.addEventListener('load', () => {
   console.log('win load');
 }, false);
 
 window.addEventListener('unload', () => {}, false);
 